function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 8.30999C9.97 8.30999 8.31 9.95999 8.31 12C8.31 14.04 9.96 15.69 12 15.69C14.04 15.69 15.69 14.04 15.69 12C15.69 9.95999 14.04 8.30999 12 8.30999ZM12 13.7C11.06 13.7 10.29 12.93 10.29 11.99C10.29 11.05 11.06 10.28 12 10.28C12.94 10.28 13.71 11.05 13.71 11.99C13.71 12.93 12.94 13.7 12 13.7ZM21.82 11.59C20.2 7.95999 16.34 5.60999 12 5.60999C7.66 5.60999 3.8 7.95999 2.18 11.6L2 12L2.18 12.4C3.8 16.03 7.65 18.38 12 18.38C16.35 18.38 20.2 16.03 21.82 12.4L22 12L21.82 11.6V11.59ZM12 16.4C8.6 16.4 5.59 14.69 4.18 12C5.58 9.30999 8.6 7.59999 12 7.59999C15.4 7.59999 18.41 9.30999 19.82 12C18.42 14.69 15.4 16.4 12 16.4Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=Eye.js.map